import { render, staticRenderFns } from "./home-component-selector.vue?vue&type=template&id=fdea0210&"
import script from "./home-component-selector.vue?vue&type=script&lang=js&"
export * from "./home-component-selector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports